<template>
  <div class="bank-picker">
    <div class="bank-picker__grid">
      <BankPicketItem v-for="(bank,i) in banks" :key="i"
                      :bank="bank"
                      :active="activeId === bank.id"
                      @click.native="$emit('select',bank)"/>
    </div>
  </div>
</template>

<script>
import BankPicketItem from "@/components/cabinet/SpaceSettings/BanksIntegrations/BankPicker/BankPicketItem";

export default {
  name: "BankPicker",
  components: {BankPicketItem},
  props: {
    banks: {
      type: Array,
      required: true
    },
    activeId: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-picker {
  @apply bg-block rounded border border-border;
  padding: 16px 12px 16px 16px;
  max-height: 302px;
  overflow-y: auto;

  &__grid {
    @apply grid;
    grid-template-columns: repeat(2, calc(50% - 7px));
    grid-column-gap: 7px;
    grid-row-gap: 5px;

    @media(min-width: 1230px){
      grid-template-columns: repeat(4, calc(25% - 7px));
    }
  }
}
</style>